// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerCard_container__EJxbS","centered":"ContainerCard_centered__aY4T6"};